import { render, staticRenderFns } from "./Reclamacion.vue?vue&type=template&id=fbba2d72&scoped=true&"
import script from "./Reclamacion.vue?vue&type=script&lang=js&"
export * from "./Reclamacion.vue?vue&type=script&lang=js&"
import style0 from "./Reclamacion.vue?vue&type=style&index=0&id=fbba2d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbba2d72",
  null
  
)

export default component.exports